import { apiEnvironment } from '../smoothr-web-app-core/environments/apiEnvironment';

export const customerGroup = 'el_kiosko';

const supportEmail = {
	[customerGroup]: `${customerGroup}@smoothr.de`,
};
const firebaseConfig = {
	[customerGroup]: {
		apiKey: 'AIzaSyDNtRjU2njZICd1bVEsnMOzoAh5GuTduNE',
		authDomain: 'tigerstaden-c297f.firebaseapp.com',
		projectId: 'tigerstaden-c297f',
		storageBucket: 'tigerstaden-c297f.firebasestorage.app',
		messagingSenderId: '808230999538',
		appId: '1:808230999538:web:7f8e93c927a8560d5b476b',
	},
};
export const environment = {
	customerGroup,
	webAppUrl: window.location.protocol + '//' + window.location.host,
	placesApiKey: 'AIzaSyAUJ0yCbuGUs9lDKehj-VGlD0oeU3XO__A',
	SUPPORT_EMAIL: supportEmail[customerGroup],
	firebaseConfig: firebaseConfig[customerGroup],
	countryList: ['de'],
	APAY_MERCHANT_ID: 'merchant.smoothr.' + customerGroup + '-dev',
	allergens_link: '',
	...apiEnvironment,
	hasRecommendations: true,
	hjid: 5035140,
	merchantId: '1110017883',
	merchantGoogleId: '01234567890123456789',
};
